export class DailyStatsConstants {
  public static readonly HOLIDAY = "Holiday";
  public static readonly NATIONAL_HOLIDAY = "National Holiday";
  public static readonly PROJECT = "Project";
}
